import script from "./CalendarMatchItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarMatchItem.vue?vue&type=script&setup=true&lang=js"

import "./CalendarMatchItem.vue?vue&type=style&index=0&id=181cb89e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-181cb89e"]])

export default __exports__